import {Box, Stack, Typography} from '@mui/material';
import {InputField} from '@/pages/components/common';
import {AuditProgramSectionVO} from '@/services/auditService/auditProgramService';
import type {W6Page} from '@/pages/components/audit-program/w-section/constants';
import {W6_PAGE} from '@/pages/components/audit-program/w-section/constants';
import ProgramSectionHeader from '@/pages/components/audit-program/a-section/ProgramSectionHeader';

export interface W6ReportViewProps {
    header: AuditProgramSectionVO;
    page: W6Page;
    refCode?: string;
    values: Record<string, string>;
    onChange: (key: string, value: string) => void;
}

/** W6 — Reporting to the group auditor. */
export default function W6ReportView({
    header,
    page,
    refCode = 'W6',
    values,
    onChange,
}: W6ReportViewProps) {
    const meta = {
        title: page.title || W6_PAGE.title,
        note: page.note || W6_PAGE.note,
        sections: page.sections?.length ? page.sections : W6_PAGE.sections,
    };

    return (
        <Box sx={{p: 2}}>
            <ProgramSectionHeader
                header={header}
                variant="a12"
                refCode={refCode}
                values={values}
                onChange={onChange}
            />
            <Typography variant="subtitle1" fontWeight={700} sx={{textAlign: 'center', mb: 1, mt: 0.5}}>
                {meta.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>
                {meta.note}
            </Typography>
            <Stack spacing={2}>
                {meta.sections.map((sec) => (
                    <Box key={sec.id}>
                        <Typography variant="subtitle2" fontWeight={700} sx={{mb: 0.75}}>
                            {sec.title}
                        </Typography>
                        <InputField
                            type="text"
                            fullWidth
                            compact
                            multiline
                            minRows={2}
                            value={values[sec.id] ?? ''}
                            onChange={(e) => onChange(sec.id, e.target.value)}
                        />
                    </Box>
                ))}
            </Stack>
        </Box>
    );
}
